import React, { useEffect, useRef } from "react";

const HERO_FALLBACK_IMG =
  "https://static.prod-images.emergentagent.com/jobs/3c0dfd58-edf3-43de-94bb-9a0fc30d9282/images/554dab40d961d80481d6ccd1e943c6c86b47ceb594c520321cf452bb00d69c28.png";

// A 30-second hand-off / driving footage. Swap with your own raw video later.
// Pexels-hosted (free for any use): "Driving downtown at night"
const DEFAULT_HERO_VIDEO =
  "https://videos.pexels.com/video-files/2103099/2103099-uhd_3840_2160_30fps.mp4";

/**
 * HeroMedia plays a looping muted video when REACT_APP_HERO_VIDEO_URL is set
 * (or the default Pexels driving clip), and falls back to a still image when
 * the video can't load. Always shows a poster (static image) while loading.
 */
const HeroMedia = ({ posterUrl = HERO_FALLBACK_IMG }) => {
  const videoUrl = process.env.REACT_APP_HERO_VIDEO_URL || DEFAULT_HERO_VIDEO;
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = true;
    v.play().catch(() => {
      // ignore — autoplay may be blocked on slow connections
    });
  }, []);

  return (
    <>
      <img
        src={posterUrl}
        alt="Movix car rental hero"
        className="absolute inset-0 w-full h-full object-cover"
        data-testid="hero-poster-image"
      />
      {videoUrl && (
        <video
          ref={videoRef}
          src={videoUrl}
          poster={posterUrl}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="absolute inset-0 w-full h-full object-cover"
          data-testid="hero-video"
          onError={(e) => {
            // hide the video if it fails — image stays underneath
            e.currentTarget.style.display = "none";
          }}
        />
      )}
    </>
  );
};

export default HeroMedia;
